export default __webpack_public_path__ + "static/media/barcode.c51d4a3b.png";